// Module
var code = "<div class=\"hotspot hotspot-logo\"> <div class=\"spot-center switching\"> <div class=\"logo-container\"> <img class=\"logo-image\" src=\"#\"/> </div> </div> </div>";
// Exports
module.exports = code;